import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import { AppContext } from '../../context/AppContext';
import SEO from '../../components/SEO';
import './blog.css';

const Blog = () => {
  const { language } = useContext(AppContext);

  const dncVideos = [
    {
      id: 1,
      url: 'https://www.youtube.com/embed/9RgTYbBJ_f0',
      title: language === 'ar' ? 'فيديو 1 - أحنا معاك' : 'Vidéo 1 - Ahnaa Maak',
      description: language === 'ar' ? 'اكتشف كيف يمكن للمنظومة الوطنية للفرصة الجديدة أن تساعدك في بناء مستقبلك المهني' : 'Découvrez comment le Dispositif National Nouvelle Chance peut vous aider à construire votre avenir professionnel'
    },
    {
      id: 2,
      url: 'https://www.youtube.com/embed/5k5MYG5XfL0',
      title: language === 'ar' ? 'فيديو 2 - أحنا معاك' : 'Vidéo 2 - Ahnaa Maak',
      description: language === 'ar' ? 'تعرف على قصص نجاح المستفيدين من المنظومة' : 'Découvrez les histoires de réussite des bénéficiaires du dispositif'
    },
    {
      id: 3,
      url: 'https://www.youtube.com/embed/6emv7iT5iBg',
      title: language === 'ar' ? 'فيديو 3 - أحنا معاك' : 'Vidéo 3 - Ahnaa Maak',
      description: language === 'ar' ? 'استكشف البرامج التدريبية والفرص المتاحة' : 'Explorez les programmes de formation et les opportunités disponibles'
    },
    {
      id: 4,
      url: 'https://www.youtube.com/embed/L6OooGAcHGA',
      title: language === 'ar' ? 'فيديو 4 - أحنا معاك' : 'Vidéo 4 - Ahnaa Maak',
      description: language === 'ar' ? 'شاهد كيف نساعد الشباب على تحقيق أهدافهم' : 'Voyez comment nous aidons les jeunes à atteindre leurs objectifs'
    }
  ];

  const podcastVideos = [
    {
      id: 1,
      url: 'https://www.youtube.com/embed/DEsl7Y_TY0k',
      title: language === 'ar' ? 'بودكاست 1' : 'Podcast 1',
      description: language === 'ar' ? 'استمع إلى قصص ملهمة من المستفيدين' : 'Écoutez des histoires inspirantes de bénéficiaires'
    },
    {
      id: 2,
      url: 'https://www.youtube.com/embed/-PuvkozWlWY',
      title: language === 'ar' ? 'بودكاست 2' : 'Podcast 2',
      description: language === 'ar' ? 'تجارب واقعية في عالم العمل' : 'Expériences réelles dans le monde du travail'
    },
    {
      id: 3,
      url: 'https://www.youtube.com/embed/uEYf4fIYU7A',
      title: language === 'ar' ? 'بودكاست 3' : 'Podcast 3',
      description: language === 'ar' ? 'نصائح وإرشادات للنجاح المهني' : 'Conseils et orientations pour la réussite professionnelle'
    },
    {
      id: 4,
      url: 'https://www.youtube.com/embed/WKQKYr2yetA',
      title: language === 'ar' ? 'بودكاست 4' : 'Podcast 4',
      description: language === 'ar' ? 'حوارات مع خبراء التوظيف' : 'Dialogues avec des experts en emploi'
    },
    {
      id: 5,
      url: 'https://www.youtube.com/embed/5q9axuezNx8',
      title: language === 'ar' ? 'بودكاست 5' : 'Podcast 5',
      description: language === 'ar' ? 'رحلة التحول من البطالة إلى النجاح' : 'Le parcours de la transformation du chômage au succès'
    }
  ];

  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.15
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  return (
    <div className="blog-page">
      <SEO 
        title={language === 'ar' ? 'المدونة - المنظومة الوطنية للفرصة الجديدة' : 'Blog - Dispositif National Nouvelle Chance'}
        description={language === 'ar' 
          ? 'شاهد فيديوهاتنا وبودكاستاتنا حول المنظومة الوطنية للفرصة الجديدة'
          : 'Regardez nos vidéos et podcasts sur le Dispositif National Nouvelle Chance'}
        url="/blog"
        type="website"
      />

      <section className="blog-hero-section relative h-screen flex items-center justify-center overflow-hidden">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="absolute w-full h-full object-cover"
        >
          <source src="/video/blog.mp4" type="video/mp4" />
          Votre navigateur ne supporte pas la lecture de vidéos.
        </video>
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="blog-hero-content relative z-10"
        >
          <h1 className="blog-hero-title">
            {language === 'ar' ? 'المدونة' : 'Blog'}
          </h1>
          <p className="blog-hero-subtitle">
            {language === 'ar' 
              ? 'اكتشف محتوانا المرئي والصوتي'
              : 'Découvrez notre contenu vidéo et audio'}
          </p>
        </motion.div>
      </section>

      <div className="blog-container">
        <motion.section 
          className="video-section"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="section-header">
            <h2 className="section-title">
              {language === 'ar' 
                ? 'المنظومة الوطنية للفرصة الجديدة - أحنا معاك'
                : 'Dispositif National Nouvelle Chance - Ahnaa Maak'}
            </h2>
            <p className="section-description">
              {language === 'ar'
                ? 'شاهد سلسلة الفيديوهات التعريفية بالمنظومة'
                : 'Regardez notre série de vidéos de présentation du dispositif'}
            </p>
          </div>

          <motion.div 
            className="videos-grid"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {dncVideos.map((video) => (
              <motion.div 
                key={video.id} 
                className="video-card"
                variants={itemVariants}
              >
                <div className="video-wrapper">
                  <iframe
                    src={video.url}
                    title={video.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="video-iframe"
                  ></iframe>
                </div>
                <div className="video-info">
                  <h3 className="video-title -mb-2 font-bold">{video.title}</h3>
                  <p className="video-description -mt-2mb-2 font-semibold">{video.description}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </motion.section>

        <motion.section 
          className="video-section podcast-section"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="section-header">
            <h2 className="section-title">
              {language === 'ar' 
                ? 'بودكاست الفرصة الجديدة'
                : 'Podcast Nouvelle Chance'}
            </h2>
            <p className="section-description">
              {language === 'ar'
                ? 'استمع إلى قصص ملهمة وتجارب واقعية'
                : 'Écoutez des histoires inspirantes et des expériences réelles'}
            </p>
          </div>

          <motion.div 
            className="videos-grid"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {podcastVideos.map((video) => (
              <motion.div 
                key={video.id} 
                className="video-card"
                variants={itemVariants}
              >
                <div className="video-wrapper">
                  <iframe
                    src={video.url}
                    title={video.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="video-iframe"
                  ></iframe>
                </div>
                <div className="video-info">
                  <h3 className="video-title">{video.title}</h3>
                  <p className="video-description">{video.description}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </motion.section>
      </div>
    </div>
  );
};

export default Blog;
